import React from 'react';
import { Spin } from 'antd';

import './spin-loader.less';

interface Props {
  children?: any;
  isLoading: boolean;
  onTop?: boolean;
}

const SpinLoader = ({ children, isLoading, onTop=false}: Props) => {
  if (onTop) {
    return (
        isLoading ?
            <div className="spin-loader-on-top">
                <Spin className="spin-container" size="large" />
                {children}
            </div> :
            children
    );
  } else {
    return (
       isLoading ?
      <div className="spin-loader">
        <Spin size="large" />
      </div> :
       children
    );
  }

};

export default SpinLoader;
